<template>
  <div>
    <breadcrumb :items="breadcrumbs"></breadcrumb>
    <v-container fluid>
      <div class="d-flex mb-4">
        <h2>{{ $t('dailyTask') }}</h2>
        <v-spacer></v-spacer>
        <v-btn
            color="primary"
            dark
            small
            class="mr-2"
            :to="{ name: 'CreateTask'}" 
        >
           {{ $t('addTask') }} 
        </v-btn>
      </div>
      <v-card elevation="0" class="px-5">
        <v-card-text>
          <template>
            <v-tabs class="tabs-pill" v-model="tab">
              <v-tab @click="changeTaskStatusType('pending')"
                > {{$t('pending')}} ({{ statusCount.pending }})</v-tab
              >
              <v-tab @click="changeTaskStatusType('todaypending')"
                > {{$t('todayPending')}}({{ statusCount.todaypending }})</v-tab
              >
              <v-tab @click="changeTaskStatusType('inprogress')"
                > {{$t('inProgress')}} ({{ statusCount.inprogress }})</v-tab
              >
              <v-tab @click="changeTaskStatusType('done')"
                > {{$t('completed')}} ({{ statusCount.completed }})</v-tab
              >
            </v-tabs>
          </template>
      
          <v-data-table
            :headers="headers"
            :items="items"
            :items-per-page="10"
            :loading="loading"
            :loading-text="$t('loadingTaskMsg')"
            :footer-props="{
              'items-per-page-options': [10, 25, 50],
              'show-first-last-page': true,
              'show-current-page': true,
              'items-per-page-text': 'Users per page',
            }"
            :header-props="{
              'sort-icon': 'mdi-unfold-more-horizontal'
            }"
            :options.sync="options"
            hide-default-footer
          >
            <template v-slot:top>
              <div class="d-flex mt-5">
                <v-text-field
                  prepend-inner-icon="mdi-magnify"
                  outlined
                  height="5px"
                  placeholder="Search"
                  dense
                  v-model="search"
                  @click:append="searchUsers"
                  @input="resetSearchOnEmpty"
                  class="shrink"
                ></v-text-field>
                <!-- <v-btn
                  :disabled="search.length < 1"
                  color="primary"
                  height="40"
                  width="40"
                  max-width="40"
                  outlined
                  class="ml-8"
                  @click="searchUsers"
                >
                  <v-icon>mdi-filter-outline</v-icon>
                </v-btn> -->
                <v-spacer></v-spacer>
                <div class="py-1 title">
                  {{ from }} - {{ to }} of {{ totalTasks }}
                </div>
                <v-btn
                  class="mx-2"
                  fab
                  small
                  outlined
                  color="primary"
                  :disabled="options.page <= 1"
                  @click="pageChange(false)"
                >
                  <v-icon dark> mdi-chevron-left </v-icon>
                </v-btn>
                <v-btn
                  class="mx-2"
                  fab
                  small
                  outlined
                  color="primary"
                  :disabled="options.page >= totalPages"
                  @click="pageChange(true)"
                >
                  <v-icon dark> mdi-chevron-right </v-icon>
                </v-btn>
            <!-- <v-btn
                    class="mx-2"
                    fab
                    small
                    outlined
                    color="primary"
                    disabled
                >
                    <v-icon dark>
                        mdi-cog-outline
                    </v-icon>
                </v-btn> -->
              </div>
            </template>
            <template v-slot:progress>
              <v-progress-linear
                color="primary"
                :height="6"
                indeterminate
              ></v-progress-linear>
            </template>
            <template v-slot:no-data v-if="items.length < 1">
              {{ $t('actionListmod.noTaskAvailable') }}
            </template>
            <template v-if="items.length > 0" v-slot:body="{ items }">
              <tbody>
                <tr
                  v-for="item in items"
                  :key="item.TENumber"
                  @mouseover="selectItem(item)"
                  @mouseleave="unSelectItem()"
                  style="position: relative; width: 0; height: 0"
                  @click="
                    $router.push({
                      name: 'SingleDailyTask',
                      params: { task_id: item.TENumber },
                    })
                  "
                >
                  <td class="capitlize">
                    <div class="subtitle-2">
                      {{ item.name }}
                    </div>
                    <div class="body-2">
                      Task ID #{{ item.TENumber }}
                    </div>
                  </td>
                  <td>
                    <template v-if="item.assignee.length > 0">
                      <v-avatar
                        color="primary"
                        size="24"
                        class="mr-n2"
                        :title="user.user.name"
                        v-for="(user, i) in item.assignee.slice(0, 2)"
                        :key="i"
                      >
                        <span class="white--text">{{user.user.name[0]}}</span>
                      </v-avatar>
                      <v-icon
                        v-if="item.assignee.length >= 2"
                        title="More"
                        size="30"
                        color="primary"
                        >mdi-dots-horizontal-circle</v-icon
                      >
                    </template>
                    <!-- <v-avatar
                            color="primary"
                            size="24"
                            class="mr-n2"
                            title="B name"
                        >
                            <span class="white--text">BS</span>
                        </v-avatar>
                        <v-avatar
                            color="primary"
                            size="24"
                            class="mr-n2"
                            title="T Name"
                        >
                            <span class="white--text">TS</span>
                        </v-avatar> -->
                  </td>
                  <!-- <td>{{ item.TENumber }}</td> -->
                  
                  <!-- <td class="capitlize">{{ item.startDate }}</td> -->
                  <td class="capitlize text-center">
                    {{ item.dueDate }}
                  </td>
                  <td class="capitlize text-center">
                    {{ item.animal.length }}
                  </td>
                  <td>
                    {{
                      item.location.length > 0
                        ? item.location[0].farmNumber
                        : "Not Assigned"
                    }}
                  </td>
                  <td>
                    <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                                <v-btn 
                                    x-small 
                                    fab
                                    v-bind="attrs"
                                    v-on="on"
                                    color="primary"
                                    outlined
                                    depressed
                                    class="mr-2"
                                    @click.stop="$router.push({name: 'UpdateTask', params: {task_id: item.TENumber}})"
                                >
                                    <v-icon>mdi-pencil</v-icon> 
                                </v-btn>
                            </template>
                            <span>Edit</span>
                        </v-tooltip>
                  </td>
                  <!-- <div style="position: absolute; right: 10px; top:5px;" v-if="item === selectedItem">  
                        <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                                <v-btn 
                                    x-small 
                                    fab
                                    v-bind="attrs"
                                    v-on="on"
                                    class="green-shadow"
                                >
                                    <v-icon>mdi-pencil</v-icon> 
                                </v-btn>
                            </template>
                            <span>Edit</span>
                        </v-tooltip>
                        <v-tooltip bottom v-if="showStatusType == 'active'">
                            <template v-slot:activator="{ on, attrs }">
                                <v-btn 
                                    x-small 
                                    fab
                                    v-bind="attrs"
                                    v-on="on"
                                    class="ml-1 green-shadow"
                                    > 
                                        <v-icon>mdi-trash-can</v-icon> 
                                </v-btn>
                            </template>
                            <span>Deactivate</span>
                        </v-tooltip>
                        <v-tooltip bottom v-else>
                            <template v-slot:activator="{ on, attrs }">
                                <v-btn 
                                    x-small 
                                    fab
                                    v-bind="attrs"
                                    v-on="on"
                                    class="ml-1 green-shadow"
                                    > 
                                        <v-icon>mdi-play</v-icon> 
                                </v-btn>
                            </template>
                            <span>Activate</span>
                        </v-tooltip>
                    </div> -->
                </tr>
              </tbody>
            </template>
          </v-data-table>
        </v-card-text>
      </v-card>
    </v-container>
  </div>
</template>

<script>
import loadingMixin from "@/mixins/LoadingMixin";

// import UserService from "@/_services/UserService"

export default {
  mounted() {
    document.title = "Action List - Daily Task";
  },
  created() {
    if (this.checkBreakPoints) this.tabletGetDailyTasks();
  },
  computed: {
    checkBreakPoints() {
      if (this.$vuetify.breakpoint.width <= 980) return true;
      return false;
    },
  },
  watch: {
    options: {
      handler() {
        this.getTaskData();
      },
      deep: true,
    },
  },
  methods: {
    // userAdded(res) {
    //   if(res.success) {
    //     this.getUsers()
    //     this.$notify({
    //       title: 'User Added',
    //       text: res.message,
    //       type: 'success'
    //     });
    //   }else{
    //     this.$notify({
    //       title: 'User Not Added',
    //       text: res.message,
    //       type: 'error'
    // 			  });
    //   }
    // },
    // userUpdated(res) {
    //   if(res.success) {
    //     this.getUsers()
    //     this.$notify({
    //       title: 'User Updated',
    //       text: res.message,
    //       type: 'success'
    //     });
    //   }else{
    //     this.$notify({
    //       title: 'User Not Updated',
    //       text: res.message,
    //       type: 'error'
    // 			  });
    //   }
    // },
    selectItem(item) {
      this.selectedItem = item;
    },
    unSelectItem() {
      this.selectedItem = false;
    },
    getDailyTasks() {
      this.loading = true;
      this.$store
        .dispatch("getDailyTasks", {payLoad: this.options, status: this.showStatusType, search: this.search})
        .then((res) => {
          if (res.success) {
            this.items = res.data.task.rows;
            this.totalTasks = res.data.task.total_rows;
            this.statusCount.pending = res.data.count.pending;
            this.statusCount.todaypending = res.data.count.todaypending;
            this.statusCount.inprogress = res.data.count.inprogress;
            this.statusCount.completed = res.data.count.completed;
            this.totalPages = Math.ceil(
              this.totalTasks / this.options.itemsPerPage
            );
            this.from = (this.options.page - 1) * this.options.itemsPerPage + 1;
            this.to =
              this.options.page * this.options.itemsPerPage -
              (this.options.itemsPerPage - res.data.task.num_rows);
            this.loading = false;
          }
        })
        .catch((err) => {
          this.loading = false;
          //     this.items = []
          console.log(err);
          //     // if(err.response.status == 403)
          //         // this.$router.go(-1)
        });
    },
    tabletGetDailyTasks() {
      this.loading = true;
      this.$store
        .dispatch("getDailyTasks", {payLoad: this.options, status: this.showStatusType})
        .then((res) => {
          console.log("tbl", res);
          if (res.success) {
            this.items = res.data.task.rows;
            this.totalTasks = res.data.task.total_rows;
            this.statusCount.pending = res.data.count.pending;
            this.statusCount.todaypending = res.data.count.todaypending;
            this.statusCount.inprogress = res.data.count.inprogress;
            this.statusCount.completed = res.data.count.completed;
            this.totalPages = Math.ceil(
              this.totalTasks / this.tabletTableOptions.itemsPerPage
            );
            this.from =
              (this.tabletTableOptions.page - 1) *
                this.tabletTableOptions.itemsPerPage +
              1;
            this.to =
              this.tabletTableOptions.page *
                this.tabletTableOptions.itemsPerPage -
              (this.tabletTableOptions.itemsPerPage - res.data.task.num_rows);
            this.loading = false;
          }
        })
        .catch((err) => {
          this.loading = false;
          //     this.items = []
          console.log(err);
          //     // if(err.response.status == 403)
          //         // this.$router.go(-1)
        });
    },

    changeTaskStatusType(type) {
      if (this.showStatusType == type) return;
      this.showStatusType = type;
      console.log('ss', this.showStatusType)
      this.options.page = 1;
      this.getDailyTasks();
    },

    searchUsers() {
      if (this.search == "") return;
      // if (this.checkBreakPoints) {
      //   this.tabletTableOptions.page = 1;
      //   this.tabletGetDailyTasks();
      // } else {
      this.options.page = 1;
      this.items = []
      this.getDailyTasks();
      // }
    },

    resetSearchOnEmpty() {
      // if (this.search == "") return;
      if (this.checkBreakPoints) {
        this.tabletTableOptions.page = 1;
        this.tabletGetDailyTasks();
      } else {
        this.options.page = 1;
        this.getDailyTasks();
      }
    },

    getTaskData() {
      this.getDailyTasks();
    },

    pageChange(t) {
      if (t) this.options.page = this.options.page + 1;
      else this.options.page = this.options.page - 1;

      this.getTaskData();
    },
    tabletPageChange(t) {
      if (t) this.tabletTableOptions.page = this.tabletTableOptions.page + 1;
      else this.tabletTableOptions.page = this.tabletTableOptions.page - 1;
      this.tabletGetDailyTasks();
    },
  },
  data() {
    return {
      importKey: 1,
      tab: 0,
      from: 0,
      to: 0,
      totalPages: 1,
      showingRows: 0,
      pageCount: 0,
      transition: true,
      totalTasks: 0,
      statusCount: {
        pending:0,
        todaypending: 0,
        inprogress:0,
        completed:0
      },
      options: {},
      tabletTableOptions: { itemsPerPage: 5, page: 1, sortBy: [] },
      showStatusType: "pending",
      search: "",
      selected: [],
      items: [],
      selectedItem: false,
      loading: false,
      loadingText: "Loading... Please wait",
      breadcrumbs: [
        {
          text: "Dashboard",
          disabled: false,
          to: "/",
        },
        {
          text: "Action List",
          disabled: false,
          to: { name: "ActionList" },
          exact: true,
        },
        {
          text: "Daily Task",
          disabled: true,
        },
      ],
      headers: [
        {
          text: this.$t('task'),
          value: "name",
          class: "black--text",
        },
        {
          text: this.$t('assignedTo'),
          align: "start",
          sortable: false,
          value: "name",
          class: "black--text",
        },
        // {
        //   text: "Task id",
        //   value: "email",
        //   class: "black--text",
        // },
        // {
        //   text: "Task",
        //   value: "role",
        //   sortable: false,
        //   class: "black--text",
        // },
        // {
        //   text: "Created date",
        //   value: "department",
        //   class: "black--text",
        // },
        {
          text: this.$t('dueDate'),
          value: "dueDate",
          align: "center",
          
          class: "black--text",
        },
        {
          text: this.$t('numberOfAnimals'),
          value: "status",
          align: "center",
          sortable: false,
          class: "black--text",
        },
        {
          text: this.$t('farm.farmID'),
          value: "status",
          align: "left",
          sortable: false,
          class: "black--text",
        },
        {
          text: this.$t('actions'),
          value: "actions",
          align: "left",
          sortable: false,
          class: "black--text",
        },
      ],
    };
  },
  mixins: [loadingMixin],
};
</script>

<style lang="scss" scoped>
::v-deep .v-tab:hover {
  background-color: #caf1e2;
  color: $primary_color !important;
}
::v-deep .v-data-table-header {
  background: $secondary2-color;
}
::v-deep .v-data-table-header span {
  text-transform: uppercase !important;
  color: black;
}
::v-deep .green-shadow:hover {
  background-color: $primary_color;
  color: white;
}

.flex-center {
  display: flex;
  align-items: center;
  //   justify-content: center;
}
</style>